import { z } from "zod";

import { EMPLOYER_REFERRALS_ORDER_BY } from "../../constants";

export const schemaForEmployerReferralsFilters = z.object({
  order_by: z.nativeEnum(EMPLOYER_REFERRALS_ORDER_BY).optional(),
  order_dir: z.union([z.literal("asc"), z.literal("desc")]).optional(),
  search: z.string().optional(),
});
